import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class ComboService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    try{
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    }catch(e){}
  }

  ComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `Combo/Load`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ApprovalComboLoad(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ApprovalMatrix_Combo/Load`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_FillComboLoadSingleType(ComboDetail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_FillComboLoadSingle/Type`,
      this.session.SetClass(ComboDetail)
    ).pipe(map(response => {
      if(response.Error_Code == '11' || response.Error_Code == '02'){
        this.session.End();
      }else{
        return response;
      }
    }));
  }

  ESS_AdditionalFillCombo(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_Additional/FillCombo`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  StaffCostCenterUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_StaffCostCenter_INSERT/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  PerquisiteTransactionDetailsLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_PerquisiteTransactionDetails_Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_PerquisiteTransactionDetails_Insert(Detail: any){
    return this.http.post<any>(environment.API_URL + `ESS_PerquisiteTransactionDetails_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
